import {ApiBaseService} from "@portal/api/api-base-service";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UserAddRequest} from "@portal/api/requests/users/user-add-request";
import {Observable} from "rxjs";
import {Guid} from "guid-typescript";
import {ListResponse} from "@portal/api/responses/api-response";
import {SearchRequest} from "@portal/api/requests/search-request";
import {UserListResponse} from "@portal/api/responses/users/user-list-response";
import { UserUpdateRequest } from "../requests/users/user-update-request";
import {BrandAddRequest} from "@portal/api/requests/brands/brand-add-request";
import {BrandUpdateRequest} from "@portal/api/requests/brands/brand-update-request";
import {BrandListResponse} from "@portal/api/responses/brands/brand-list-response";
import {ModelAddRequest} from "@portal/api/requests/models/model-add-request";
import {ModelUpdateRequest} from "@portal/api/requests/models/model-update-request";
import {ModelsListResponse} from "@portal/api/responses/models/models-list-response";
import {EcuTypeAddRequest} from "@portal/api/requests/ecu-type/ecu-type-add-request";
import {EcuTypeUpdateRequest} from "@portal/api/requests/ecu-type/ecu-type-update-request";
import {EcuTypesListResponse} from "@portal/api/responses/ecu-types/ecu-types-list-response";

@Injectable({
    providedIn: 'root'
})
export class EcuTypesService extends ApiBaseService {
    controller = 'ecu-types';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    add(obj: EcuTypeAddRequest): Observable<Guid> {
        return this.post<Guid, EcuTypeAddRequest>(obj, this.controller);
    }

    update(obj: EcuTypeUpdateRequest): Observable<Guid> {
        return this.put<Guid, EcuTypeUpdateRequest>(obj, this.controller);
    }

    getFormEdit(id: Guid): Observable<EcuTypeUpdateRequest> {
        return this.get<EcuTypeUpdateRequest>(this.controller + `/form/${id}`);
    }

    list(obj: SearchRequest): Observable<ListResponse<EcuTypesListResponse[]>> {
        return this.post<ListResponse<EcuTypesListResponse[]>, SearchRequest>(obj, this.controller + `/list`);
    }

    deleteEcuType(id: Guid): Observable<boolean> {
        return this.delete<boolean>(`${this.controller}/${id}`);
    }
}
